import {match, P} from 'ts-pattern'
import {ChildrenProps, StyleProps} from './uiType'
import {twMerge} from 'tailwind-merge'

export const HrText = ({
  children,
  className,
  classNames
}: ChildrenProps & StyleProps & {classNames?: {root?: string; label?: string; hr?: string}}) => (
  <div className={twMerge(`flex items-center w-full`, className, classNames?.root)}>
    <hr className={twMerge('flex-1', classNames?.hr)} />
    {match(children)
      .with(P.string, children => (
        <div className={twMerge('px-2 text-gray-400 font-semibold', classNames?.label)}>{children}</div>
      ))
      .otherwise(() => children)}
    <hr className={twMerge('flex-1', classNames?.hr)} />
  </div>
)

export const LabelType = ({children, className = ''}: ChildrenProps & StyleProps) => (
  <h3 className={`uppercase text-gray-400 ${className}`}>{children}</h3>
)

export const LabelForm = ({children, className = ''}: ChildrenProps & StyleProps) => (
  <p className={twMerge(`text-gray-500 font-medium`, className)}>{children}</p>
)

export const LabelEmptyList = ({children, className = ''}: ChildrenProps & StyleProps) => (
  <div className={`w-full text-center font-bold text-gray-300 ${className}`}>{children}</div>
)
